import React, { useEffect, useState } from 'react';
import { Plus, CheckCircle2, Circle, Trash2, AlertTriangle } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { fmtDate, errMsg } from './crmConstants';

const QUICK = [
  { label: 'Domani', days: 1 }, { label: 'Tra 2 giorni', days: 2 }, { label: 'Tra 1 settimana', days: 7 },
];
const plusDays = (d) => { const t = new Date(); t.setDate(t.getDate() + d); t.setHours(9, 30, 0, 0); return t; };
const toLocalInput = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);

export const LeadTasks = ({ api, lead, team, showToast, onChanged }) => {
  const [tasks, setTasks] = useState([]);
  const [title, setTitle] = useState('');
  const [due, setDue] = useState(toLocalInput(plusDays(2)));
  const [assignee, setAssignee] = useState('');
  const load = () => api.get(`/admin/leads/${lead.id}/tasks`).then(setTasks).catch(() => {});
  useEffect(() => { load(); }, [lead.id]);

  const add = async () => {
    try {
      await api.post(`/admin/leads/${lead.id}/tasks`, { title, due_at: due ? new Date(due).toISOString() : '', assignee_id: assignee });
      setTitle(''); load(); onChanged();
    } catch (e) { showToast('error', errMsg(e)); }
  };
  const toggle = async (t) => { await api.patch(`/admin/lead-tasks/${t.id}`, { done: !t.done }); load(); onChanged(); };
  const remove = async (t) => { await api.del(`/admin/lead-tasks/${t.id}`); load(); onChanged(); };
  const now = new Date().toISOString();

  return (
    <div className="space-y-4" data-testid="lead-tasks">
      <div className="bg-slate-800/60 border border-slate-700 rounded-xl p-3 space-y-2">
        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Prossima azione (es. Richiamare per fissare la call)" className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm" data-testid="task-title-input" />
        <div className="flex flex-wrap gap-2 items-center">
          <input type="datetime-local" value={due} onChange={(e) => setDue(e.target.value)} className="px-2 py-1.5 bg-slate-900 border border-slate-700 rounded-lg text-white text-xs" data-testid="task-due-input" />
          {QUICK.map((q) => (
            <button key={q.days} type="button" onClick={() => setDue(toLocalInput(plusDays(q.days)))} className="text-[11px] px-2 py-1 rounded-full bg-slate-700 text-slate-200 hover:bg-slate-600">{q.label}</button>
          ))}
          <select value={assignee} onChange={(e) => setAssignee(e.target.value)} className="px-2 py-1.5 bg-slate-900 border border-slate-700 rounded-lg text-white text-xs" data-testid="task-assignee-select">
            <option value="">Assegna al responsabile</option>
            {team.map((u) => <option key={u.id} value={u.id}>{u.full_name || u.username}</option>)}
          </select>
          <Button size="sm" onClick={add} disabled={!title.trim()} className="ml-auto bg-amber-500 hover:bg-amber-400 text-slate-950" data-testid="task-add-btn"><Plus className="w-4 h-4 mr-1" /> Aggiungi</Button>
        </div>
      </div>
      <div className="space-y-1.5">
        {tasks.map((t) => {
          const late = !t.done && t.due_at && t.due_at < now;
          return (
            <div key={t.id} className={`flex items-center gap-3 px-3 py-2 rounded-lg border ${late ? 'border-rose-500/40 bg-rose-500/5' : 'border-slate-800 bg-slate-800/40'}`} data-testid={`task-${t.id}`}>
              <button onClick={() => toggle(t)} data-testid={`task-toggle-${t.id}`}>
                {t.done ? <CheckCircle2 className="w-5 h-5 text-emerald-400" /> : <Circle className="w-5 h-5 text-slate-500 hover:text-amber-400" />}
              </button>
              <div className="flex-1 min-w-0">
                <p className={`text-sm ${t.done ? 'line-through text-slate-500' : 'text-white'}`}>{t.title}</p>
                <p className="text-[11px] text-slate-400 flex items-center gap-1">
                  {late && <AlertTriangle className="w-3 h-3 text-rose-400" />}
                  {t.due_at ? fmtDate(t.due_at) : 'Senza scadenza'} · {t.assignee_name || '—'}{t.done && t.done_at ? ` · fatto ${fmtDate(t.done_at)}` : ''}
                </p>
              </div>
              <button onClick={() => remove(t)} className="text-slate-500 hover:text-rose-400" data-testid={`task-delete-${t.id}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          );
        })}
        {!tasks.length && <p className="text-sm text-slate-500 text-center py-4">Nessuna attività pianificata. Aggiungi la prossima azione qui sopra.</p>}
      </div>
    </div>
  );
};
